import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';

import 'dayjs/locale/en';
import 'dayjs/locale/sv';

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
	// pass the i18n instance to react-i18next.
	.use(detector)
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		supportedLngs: ['en'],
		resources: {
			en: {
				translation: enTranslation,
			}
		},
		detection: {
			order: ['localStorage', 'querystring', 'navigator'],
			lookupQuerystring: 'lng',
			lookupLocalStorage: 'I18N_LANGUAGE',
		},
		fallbackLng: 'en',
		debug: false,
	})
	.then();

export default i18n;
